import {
    overAll1, overAll2, overAll3, overAll4, overAll5, overAll6, overAll7, overAll8,
    overAll9, overAll10, overAll11, overAll12, overAll13, overAll14, overAll15, overAll16
} from '/public/siteImages/iOSTheme/themeType';
import {
    onBoardImage1, onBoardImage2, onBoardImage3, onBoardImage4,
    onBoardImage5, onBoardImage6, onBoardImage7, onBoardImage8
} from '/public/siteImages/iOSTheme/onBoardPage';
import {
    login1, login2, login3, login4, login5, login6, login7, login8, login9, login10
} from '/public/siteImages/iOSTheme/loginPage';
import {
    forgot1, forgot2, forgot3, forgot4, forgot5, forgot6, forgot7, forgot8
} from '/public/siteImages/iOSTheme/forgotPassword';
import { input1, input2, input3, input4 } from '/public/siteImages/iOSTheme/inputType';
import { button1, button2, button3, button4 } from '/public/siteImages/iOSTheme/buttonType';
import { viewCar1, viewCar2, viewCar3, viewCar4 } from '/public/siteImages/iOSTheme/viewCar';
import { profile1, profile2, profile3, profile4 } from '/public/siteImages/iOSTheme/profile';
import {
    wishlist1, wishlist2, wishlist3, wishlist4, wishlist5, wishlist6, wishlist7, wishlist8,
    wishlist9, wishlist10, wishlist11, wishlist12, wishlist13, wishlist14, wishlist15, wishlist16, 
    wishlist17, wishlist18, wishlist19, wishlist20
} from '/public/siteImages/iOSTheme/wishlist';

export function getOverAllTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [overAll1, overAll2, overAll3, overAll4];
    else if (themeType == 2) themes = [overAll5, overAll6, overAll7, overAll8];
    else if (themeType == 3) themes = [overAll9, overAll10, overAll11, overAll12];
    else themes = [overAll13, overAll14, overAll15, overAll16];
    return themes;
}

export function getOnBoardTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [onBoardImage1];
    else if (themeType == 2) themes = [onBoardImage2, onBoardImage3, onBoardImage4];
    else if (themeType == 3) themes = [onBoardImage5, onBoardImage6, onBoardImage7];
    else themes = [onBoardImage8];
    return themes;
}

export function getLoginTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [login1, login2];
    else if (themeType == 2) themes = [login3, login4];
    else if (themeType == 3) themes = [login5, login6];
    else themes = [login7, login8, login9, login10];
    return themes;
}

export function getInputTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [input1];
    else if (themeType == 2) themes = [input2];
    else if (themeType == 3) themes = [input3];
    else themes = [input4];
    return themes;
}

export function getButtonTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [button1];
    else if (themeType == 2) themes = [button2];
    else if (themeType == 3) themes = [button3];
    else themes = [button4];
    return themes;
}

export function getForgotPasswordTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [forgot1, forgot2];
    else if (themeType == 2) themes = [forgot3, forgot4];
    else if (themeType == 3) themes = [forgot5, forgot6];
    else themes = [forgot7, forgot8];
    return themes;
}

export function getViewCarTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [viewCar1];
    else if (themeType == 2) themes = [viewCar2];
    else if (themeType == 3) themes = [viewCar3];
    else themes = [viewCar4];
    return themes;
}

export function getProfileTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [profile1];
    else if (themeType == 2) themes = [profile2];
    else if (themeType == 3) themes = [profile3];
    else themes = [profile4];
    return themes;
}

export function getWishlistTheme({ themeType }) {
    let themes = [];
    if (themeType == 1) themes = [wishlist1, wishlist2, wishlist3, wishlist4, wishlist5];
    else if (themeType == 2) themes = [wishlist6, wishlist7, wishlist8,
        wishlist9, wishlist10];
    else if (themeType == 3) themes = [wishlist11, wishlist12, wishlist13, wishlist14, wishlist15];
    else themes = [wishlist16, wishlist17, wishlist18, wishlist19, wishlist20];
    return themes;
}

export function getIOSTheme({ name, themeType }) {
    let themes = [];
    if (name == 'themeType') themes = getOverAllTheme({ themeType });
    else if (name == 'onBoardPage') themes = getOnBoardTheme({ themeType });
    else if (name == 'loginPage') themes = getLoginTheme({ themeType });
    else if (name == 'forgotPassword') themes = getForgotPasswordTheme({ themeType });
    else if (name == 'buttonType') themes = getButtonTheme({ themeType });
    else if (name == 'inputType') themes = getInputTheme({ themeType });
    else if (name == 'viewCar') themes = getViewCarTheme({ themeType });
    else if (name == 'profile') themes = getProfileTheme({ themeType });
    else if (name == 'wishlist') themes = getWishlistTheme({ themeType });
    return themes;
}



